<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
    <base-material-dialog
      :title='item.data === undefined ? "专利付款信息" : "专利付款信息" '
      :dialog="item.show"
      @on-dialog-change='dialogChange'
      persistent
      max-width='550'
      :fullscreen='$isMobile'
    >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-card-title class="px-0 py-1">可申请总额度：<span class="green--text">¥{{quotaMoney}}</span></v-card-title>
            <v-card-title class="px-0 py-1">本次申请额度：<span class="blue--text">¥{{thisMoney}}</span></v-card-title>
            <v-card-title class="px-0 py-1">剩余申请额度：
              <span class="orange--text">¥{{quotaMoney - thisMoney}}</span>
              <span class="red--text size-10" v-if="quotaMoney - thisMoney < 0">(1、联系管理员增加费用信息，2、联系客户缴纳费用)</span>
            </v-card-title>
            <v-row class="mt-1">
              <v-col>
                <v-simple-table style="border: 1px solid #e0e0e0;">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">名称</th>
                        <th class="text-left">编号</th>
                        <th class="text-left">费用</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(i, idx) in patentList" :key="idx">
                        <td>{{ i.name }}</td>
                        <td>{{ i.patentCode }}</td>
                        <td>{{ item.type == 1  ? i.acceptFee : i.authFee}}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea rows='3' label="备注信息" outlined v-model="form.remark"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" rounded v-show="quotaMoney - thisMoney >= 0" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/patent/pay.js'

  export default {
    name: 'PayApply',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null,
          type: null // 1.申请费，2.受理费
        })
      }
    },
    data() {
      return {
        loading: false,
        number: [
          value => (/^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value)) || `金额必填为数字`,
        ],
        quotaMoney: 0,
        thisMoney: 0,
        patentList: [],
        form: {
          id: '',
          type: '',
          contractId: '',
          customerId: '',
          patentCodes: '',
          acceptFee: 0,
          authFee: 0,
          money: 0,
          remark: ''
        },
        defForm: {
          id: '',
          type: '',
          contractId: '',
          customerId: '',
          patentCodes: '',
          acceptFee: 0,
          authFee: 0,
          money: 0,
          remark: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate() && this.form.money <= this.quotaMoney) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      countMoney () {
        this.form.money = Number(this.form.authFee) + Number(this.form.acceptFee)
      },
      quota () {
        const this_ = this
        this_.thisMoney = 0
        this.patentList.forEach(res => {
          if (this_.item.type === 1) {
            this_.thisMoney += res.acceptFee
            this_.form.acceptFee += res.acceptFee
          } else if (this_.item.type === 2) {
            this_.thisMoney += res.authFee
            this_.form.authFee += res.authFee
          }
          this_.form.money = this_.thisMoney
          this_.form.patentCodes += `${res.patentCode},`
        })
        this_.form.patentCodes = this_.form.patentCodes.substring(0, this_.form.patentCodes.lastIndexOf(","))
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form.type = this.item.type
            this.patentList = this.item.data
            this.form.contractId = this.item.data[0].contractId
            this.form.customerId = this.item.data[0].customerId
            this.quotaMoney = this.item.data[0].contract.lastOtherMoney
            this.quota()
          }
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null
      }
    }
  }
</script>

<style>
</style>
